import { createActionGroup, props } from '@ngrx/store';
import { ParameterEntryCyclesView, ParameterType } from '../../../_generated';

export const ParameterEntryCyclesAction = createActionGroup({
  source: 'ParameterEntryCycles',
  events: {
    Get: props<{
      siteId: number;
      shopId: number;
      toolId: number;
      emissionPointId: number;
      parameterId: number;
      entryCycleId: number;
      parameterType: ParameterType;
    }>(),
    'Get Success': props<{ payload: ParameterEntryCyclesView }>(),
    Error: props<{ error: string }>(),
  },
});
